import { getGTIN } from "../../../api/productApi";
import { isOk } from "../../../result";

export const generateEAN = async (): Promise<string> => {
  const result = await getGTIN();

  if (isOk(result)) {
    const newEAN =
      Number(result.value.substring(0, result.value.length - 1)) + 1;
    return `${newEAN}${checkDigitEAN13(newEAN.toString())}`;
  }

  return "";
};

const checkDigitEAN13 = (barcode: string) => {
  const sum = barcode
    .split("")
    .map((n: any, i) => n * (i % 2 ? 3 : 1)) // alternate between multiplying with 3 and 1
    .reduce((sum, n) => sum + n, 0); // sum all values

  const roundedUp = Math.ceil(sum / 10) * 10; // round sum to nearest 10
  // subtract round to sum = check digit
  return roundedUp - sum;
};
